import React from "react";

import ReferAndEarnDetails from "src/modules/ReferAndEarn/ReferAndEarnDetails";

type Props = {};

const ReferAndEarnPage = (props: Props) => {
  return <ReferAndEarnDetails />;
};

export default ReferAndEarnPage;
